module.exports = __webpack_public_path__ + "static/media/sea.536d59a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/login/sea.jpg
// module id = 38
// module chunks = 0